import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["disabled", "readOnly", "name", "strengthCheckField", "useStrengthCheck", "checkFields", "disableErrorContainer", "errorText", "$css", "collapseError"];
import React, { useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { useField } from 'formik';
import { useResizeDetector } from 'react-resize-detector/build/withPolyfill';
import Input from '../Input/Input';
import LinkOrButton from '../../../LinkOrButton';
import { Eye, ClosedEye } from '../../../svg';
import { flex, focus, focusStyles, hoverChild } from '../../../../styling';
import { COLORS } from '../../../../themes';
import StrengthCheck from './StrengthChecker';
import { InputError } from '../Error';
import { toAlphanumericDashString, dotToDash } from '../../../../utils';
import { Div } from '../../../Styled';
var Button = /*#__PURE__*/styled(LinkOrButton).withConfig({
  displayName: "PasswordInput__Button",
  componentId: "sc-kcxdd6-0"
})(["flex:0 0 auto;padding:0 16px;", " pointer-events:auto;border-radius:0 0.4rem 0.4rem 0;", " ", " ", ";", ";&:disabled,&.disabled{opacity:0.5;pointer-events:none;}"], flex('center', 'center'), hoverChild('path', 'stroke', COLORS.NEUTRAL_600, COLORS.PRIMARY_500), hoverChild('circle', 'fill', COLORS.NEUTRAL_600, COLORS.PRIMARY_500), focus(focusStyles), function (_ref) {
  var $visible = _ref.$visible;
  return $visible && css(["path{stroke:", " !important;}circle{fill:", " !important;}"], COLORS.PRIMARY_500, COLORS.PRIMARY_500);
});

var _ref3 = /*#__PURE__*/React.createElement(ClosedEye, null);

var _ref4 = /*#__PURE__*/React.createElement(Eye, null);

var PasswordInput = function PasswordInput(_ref2) {
  var disabled = _ref2.disabled,
      readOnly = _ref2.readOnly,
      name = _ref2.name,
      _ref2$strengthCheckFi = _ref2.strengthCheckField,
      strengthCheckField = _ref2$strengthCheckFi === void 0 ? '' : _ref2$strengthCheckFi,
      _ref2$useStrengthChec = _ref2.useStrengthCheck,
      useStrengthCheck = _ref2$useStrengthChec === void 0 ? true : _ref2$useStrengthChec,
      checkFields = _ref2.checkFields,
      disableErrorContainer = _ref2.disableErrorContainer,
      errorText = _ref2.errorText,
      $css = _ref2.$css,
      collapseError = _ref2.collapseError,
      props = _objectWithoutProperties(_ref2, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      passwordVisible = _useState2[0],
      setPasswordVisible = _useState2[1];

  var _useField = useField({
    name: name
  }),
      _useField2 = _slicedToArray(_useField, 2),
      _useField2$ = _useField2[1],
      error = _useField2$.error,
      touched = _useField2$.touched;

  var _useField3 = useField({
    name: strengthCheckField || name
  }),
      _useField4 = _slicedToArray(_useField3, 2),
      strengthCheckError = _useField4[1].error;

  var _useResizeDetector = useResizeDetector({
    refreshMode: 'debounce',
    refreshRate: 0
  }),
      width = _useResizeDetector.width,
      ref = _useResizeDetector.ref;

  var strengthId = useRef("".concat(toAlphanumericDashString(name), "-strength")).current;
  var tooltipId = useRef("".concat(toAlphanumericDashString(name), "-tooltip")).current;
  var idRef = useRef(dotToDash(name)).current;
  return /*#__PURE__*/React.createElement(Div, {
    $css: $css,
    ref: ref
  }, /*#__PURE__*/React.createElement(Input, _extends({
    disableErrorContainer: useStrengthCheck ? true : disableErrorContainer,
    disabled: disabled,
    readOnly: readOnly,
    name: name,
    "aria-describedby": useStrengthCheck ? "".concat(strengthId, " ").concat(tooltipId) : undefined
  }, props, {
    type: passwordVisible ? 'text' : 'password'
  }), /*#__PURE__*/React.createElement(Button, {
    type: "button",
    disabled: disabled || readOnly,
    $visible: passwordVisible,
    onClick: function onClick() {
      return setPasswordVisible(function (visible) {
        return !visible;
      });
    },
    "aria-label": passwordVisible ? 'Hide password' : 'Show password',
    "aria-live": "polite",
    "data-test-id": "toggle-password-visibility"
  }, passwordVisible ? _ref3 : _ref4)), useStrengthCheck && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StrengthCheck, {
    width: width || 0,
    passwordField: name,
    strengthCheckField: strengthCheckField,
    checkFields: checkFields,
    strengthId: strengthId,
    tooltipId: tooltipId
  }), /*#__PURE__*/React.createElement(InputError, {
    collapseError: collapseError,
    $css: css(["padding-top:0;"]),
    errorText: touched ? errorText || strengthCheckError || error : '',
    errorId: idRef
  })));
};

export default PasswordInput;